module.exports = __webpack_public_path__ + "img/project-icon.fd78153f.svg";